import { Link } from '@one-thd/sui-atomic-components';
import React, { useEffect } from 'react';
import { DeliveryInstructionsEdit } from '../../../../hooks/delivery-hooks';
import { useEditDeliveryInstructionsContext } from '../../../../hooks/useContexts';
import { catchButtonDisplayEvent, catchProSiteInstructionsEditLinkDisplayed, } from '../../../../utils/edit-delivery-instructions/analytics';
import '../../../../styles/order-details.scss';
export var EditDeliveryInstructions = function (_a) {
    var fulfillmentGroup = _a.fulfillmentGroup, orderDetailsData = _a.orderDetailsData, customerType = _a.customerType, fulfillmentGroupIndex = _a.fulfillmentGroupIndex;
    var handleEditDeliveryInstructions = useEditDeliveryInstructionsContext().handleEditDeliveryInstructions;
    useEffect(function () {
        var _a;
        // Track which type of delivery instructions edit link is displayed
        var isEditSiteInstructionsEnabled = (_a = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.actions) === null || _a === void 0 ? void 0 : _a.isEditSiteInstructionsEnabled;
        if (isEditSiteInstructionsEnabled) {
            // Pro Site Instructions (DFS)
            catchProSiteInstructionsEditLinkDisplayed();
        }
        else {
            // Standard Delivery Instructions
            catchButtonDisplayEvent();
        }
    }, []);
    var onClick = function () {
        DeliveryInstructionsEdit(fulfillmentGroup, orderDetailsData, handleEditDeliveryInstructions, customerType, fulfillmentGroupIndex); // will open EditDeliveryInstructionsDrawer
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "card-fix" },
            React.createElement(Link, { component: "button", variant: "body-base", onClick: onClick }, "Edit"))));
};
